var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.50002V13.75C17.9994 13.8568 17.976 13.9622 17.9314 14.0592C17.8868 14.1562 17.8219 14.2426 17.7413 14.3125C16.3088 15.5528 14.9391 16 13.6331 16C11.8603 16 10.2047 15.1806 8.66438 14.4203C6.17531 13.1875 4.01156 12.1197 1.5 14.1035V18.25C1.5 18.4489 1.42098 18.6397 1.28033 18.7803C1.13968 18.921 0.948912 19 0.75 19C0.551088 19 0.360322 18.921 0.21967 18.7803C0.0790178 18.6397 0 18.4489 0 18.25V2.50002C0.000719116 2.39317 0.0242604 2.28771 0.0690469 2.1907C0.113833 2.09369 0.178831 2.00737 0.259688 1.93752C3.63469 -0.985605 6.66375 0.511582 9.33375 1.83252C11.9062 3.10564 14.1366 4.20627 16.7587 1.93752C16.8671 1.84357 17.0002 1.78267 17.1421 1.76203C17.2841 1.7414 17.4289 1.7619 17.5596 1.8211C17.6902 1.88031 17.8012 1.97573 17.8792 2.09606C17.9573 2.2164 17.9992 2.35659 18 2.50002Z",
    fill: "#FFBD37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchIcon);
export default __webpack_public_path__ + "static/media/matchIcon.1babb3ae87992a03136494c8cdb94c1e.svg";
export { ForwardRef as ReactComponent };